<mat-card appearance="outlined" class="mat-crud-wide">
  <mat-card-header class="admin-mat-card-header">
    <mat-card-title>
      Notification Group Members
    </mat-card-title>
    <div class="card-header-text-icons">
      Reload data:
      <button mat-icon-button (click)="refresh()">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </mat-card-header>
  <mat-card-content class="card-content-grid">
    <mat-table #table [dataSource]="dataSource" matSort class="mat-cell">
      <!--- Note that these columns can be defined in any order.
      The actual rendered columns are set as a property on the row definition" -->
      <!-- ID Column-->
      <ng-container matColumnDef="Id">
        <mat-header-cell class="header no-filter" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="sort-header">Id</div>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">{{row?.Id}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="NotifyGroup.Name">
        <mat-header-cell class="header filter" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="sort-header">
            Notification Group
          </div>
          <mat-form-field>
            <mat-select [formControl]="NotifyGroupIdFilter" placeholder="Search Notification Group">
              <mat-option [value]="null">All</mat-option>
              @for (notifyGroup of administrationService.notifyGroups | filter:[{Disabled: false}]; track notifyGroup) {
                <mat-option [value]="notifyGroup?.Id">{{notifyGroup?.Name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let row">{{row?.NotifyGroup?.Name}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Station.StationName">
        <mat-header-cell class="header filter" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="sort-header">
            Platform Provider
          </div>
          <mat-form-field>
            <mat-select [formControl]="StationIdFilter" placeholder="Search Station">
              <mat-option [value]="null">All</mat-option>
              @for (station of administrationService.stations | filter:[{Disabled: false}]; track station) {
                <mat-option [value]="station?.Id">{{station?.StationName}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let row">{{row?.Station?.StationName}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="PropertyType.PropertyTypeName">
        <mat-header-cell class="header filter" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="sort-header">
            Property Type
          </div>
          <mat-form-field>
            <mat-select [formControl]="PropertyTypeIdFilter" placeholder="Search Property Type">
              <mat-option [value]="null">All</mat-option>
              @for (propertyType of calendarsService.propertyTypes() | filter:[{Disabled: false}]; track propertyType) {
                <mat-option [value]="propertyType?.Id">{{propertyType?.PropertyTypeName}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let row">{{row?.PropertyType?.PropertyTypeName}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Email">
        <mat-header-cell class="header filter" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="sort-header">
            Email
          </div>
          <mat-form-field>
            <mat-label>Search Email</mat-label>
            <input matInput class="form-field" [formControl]="EmailFilter" placeholder="Search Email" autocomplete="off">
          </mat-form-field>
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let row">{{row?.Email}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Mobile">
        <mat-header-cell class="header filter" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="sort-header">
            Mobile
          </div>
          <mat-form-field>
            <mat-label>Search Mobile</mat-label>
            <input matInput class="form-field" [formControl]="MobileFilter" placeholder="Search Mobile" autocomplete="off">
          </mat-form-field>
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let row">{{row?.Mobile}}</mat-cell>
      </ng-container>

      <!-- actions -->
      <ng-container matColumnDef="actions">
        <mat-header-cell class="header header-add-refresh" mat-header-cell *matHeaderCellDef>
          <div class="card-header-text-icons">
            Reload data:
            <button mat-icon-button (click)="refresh()">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
          @if (CanAdd) {
            <button mat-icon-button color="accent" (click)="addNew($event)" title="add">
              <i class="material-icons">add_box</i>
            </button>
          }
        </mat-header-cell>

        <mat-cell mat-cell *matCellDef="let row; let i=index;">
          @if (CanEdit) {
            <button mat-icon-button color="accent" (click)="editItem($event, row)" title="edit">
              <mat-icon aria-label="Edit">edit</mat-icon>
            </button>
          }

          @if (CanDelete) {
            <button mat-icon-button color="accent" (click)="deleteItem($event, row)" title="delete">
              <mat-icon aria-label="Delete">delete</mat-icon>
            </button>
          }
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>


    <div class="no-results" [style.display]="dataSource?.data?.length === 0 ? '' : 'none'">
      No results
    </div>

  </mat-card-content>
  <mat-card-footer>
    <mat-paginator #paginator
      [length]="dataSource?.filteredData?.length"
      [pageIndex]="0"
      [pageSize]="10"
      [pageSizeOptions]="mtCrudService.pagerPageSizes"
      showFirstLastButtons="true">
    </mat-paginator>
  </mat-card-footer>
</mat-card>
